// Use this file to expose environment variables to the client side. Do not use this file directly in client components,
// instead use the `useClientEnvironment` hook.

// !!! Note: do not add "use client" to this file, otherwise, environment variables will be set to empty strings in the browser.

import { useContext } from "react";

import { ClientEnvironmentContext } from "./client-environment-provider";
import {
  BRANCH_SDK_KEY,
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  EXTERNAL_ADDRESS,
  FACEBOOK_APP_ID,
  GOOGLE_MAPS_BROWSER_KEY,
  HANDSHAKE_ENV,
  INTERCOM_APP_ID,
  PS_ENV,
  RELEASE_TAG,
  SEGMENT_CUSTOM_DOMAIN,
  SEGMENT_IO_API_KEY,
  STATSIG_SDK_CLIENT_KEY,
} from "./server";

/**
 * Add new client-side environment variables here.
 *
 * Do not use this directly in client components. Use the `useClientEnvironment` hook instead.
 */
export const UNSAFE_CLIENT_EXPOSED_ENVIRONMENT_VARIABLES = {
  BRANCH_SDK_KEY,
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  EXTERNAL_ADDRESS,
  FACEBOOK_APP_ID,
  GOOGLE_MAPS_BROWSER_KEY,
  HANDSHAKE_ENV,
  INTERCOM_APP_ID,
  PS_ENV,
  RELEASE_TAG,
  SEGMENT_CUSTOM_DOMAIN,
  SEGMENT_IO_API_KEY,
  STATSIG_SDK_CLIENT_KEY,
};

export function useClientEnvironment() {
  const context = useContext(ClientEnvironmentContext);
  if (!context) {
    throw new Error(
      "useClientEnvironment must be used within a ClientEnvironmentProvider",
    );
  }
  return context;
}
